import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import construct from '../../../assets/images/icons/build.svg';
import { Modal, ModalBackground } from '../../assets/styles/Modal';
import { BtnGray } from '../Button';
import useBackHistory from '../../hooks/useBackHistory';

declare global {
  interface Window {
    kakao: any;
  }
}

interface Iprops {
  openModal: any;
  setOpenModal: any;
  address: any;
}

const MapContainer = ({ openModal, setOpenModal, address }: Iprops) => {
  const KAKAO_KEY = process.env.REACT_APP_KAKAO_JAVASCRIPT;
  const { t } = useTranslation();
  const mapRef = useRef();
  /*
  const imageSize = new window.kakao.maps.Size('auto', 40); // 마커이미지의 크기입니다
  const imageOption = { offset: new window.kakao.maps.Point(15, 30) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
  const [newSiteList, setNewSiteList] = useState<any[]>([]);
  const [constructMarker] = useState<any[]>([]);
  */

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${KAKAO_KEY}&autoload=false`;

    script.onload = () => {
      window.kakao.maps.load(() => {
        const container = document.getElementById('map');
        const options = {
          center: new window.kakao.maps.LatLng(address.latitude, address.longitude),
          // center: new window.window.kakao.maps.LatLng(address.latitude, address.longitude),
          level: 3,
        };
        const map = new window.kakao.maps.Map(container, options);
        mapRef.current = map;
        // 지도 확대 축소를 제어할 수 있는 줌 컨트롤을 생성합니다
        const zoomControl = new window.kakao.maps.ZoomControl();
        map.addControl(zoomControl, window.kakao.maps.ControlPosition.BOTTOMRIGHT);

        const marker = new window.kakao.maps.Marker({
          position: new window.kakao.maps.LatLng(address.latitude, address.longitude),
          // position: new window.kakao.maps.LatLng(address.latitude, address.longitude), // 마커가 표시될 위치입니다
          // image: markerImage, // 마커이미지 설정
          // clickable: true,
        });

        marker.setMap(mapRef.current);
        // map.relayout();

        const ifContent = `
          <div style="position: relative;top: -60px;">
            <span style="display: block;background: #50627F;color: #fff;font-size: 14px;text-align: center;height: 24px;line-height: 22px;border-radius: 4px;padding: 0px 10px;">
              ${address.address1}
            </div>
          </div>
        `;

        // 인포윈도우
        const customOverlay = new window.kakao.maps.CustomOverlay({
          position: new window.kakao.maps.LatLng(address.latitude, address.longitude),
          content: ifContent,
        });

        // 커스텀 오버레이를 지도에 표시합니다
        customOverlay.setMap(map);
        // infoWindow.open(map, marker);
      });
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window.kakao;
    };
  }, []);

  // 모달창 닫기
  const onClickClose = () => {
    setOpenModal((prev: any) => ({ ...prev, status: false }));
  };

  const { onBackPrev } = useBackHistory({ isOpen: openModal.status, onPrev: onClickClose, pageName: 'mapView' });

  return (
    <ModalBackground onClick={onBackPrev} role='presentation'>
      <Modal>
        <div className='modal fitHeight' role='presentation' onClick={(event) => event.stopPropagation()}>
          <div className='inputForm-head'>
            <div className='innerTabChip flex-start' style={{ gap: '0.5rem' }}>
              <h5 className='bold'>{t(`지도 보기`)}</h5>
            </div>

            <div className='closeBtn' onClick={onBackPrev} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>

          <div className='inputForm-body map-view'>
            <div id='map' style={{ width: '100%', height: '100%' }} />
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default MapContainer;
